import React, { PropTypes } from 'react';
import TextInput from '../common/TextInput';
import TextAreaInput from '../common/TextAreaInput';
import SelectInput from '../common/SelectInput';
import Button from '../common/Button';

const BulkTransferForm = ({ form, onSubmit, onChange, onCancel, onBlur, errors, data, formIsValid }) => {
  
  let questions = [];
  let topRowQuestions = [];
  
  if (form.formQuestions) {
    form.formQuestions.forEach(question => {
      question.questionParts.map(questionPart => {
        if (question.questionName === 'Establishment User Role' || question.questionName === 'Remove Establishment Association from Original User') {
          topRowQuestions.push(
            <SelectInput
              name={questionPart.questionPartName}
              label={questionPart.questionPartLabel}
              onChange={onChange}
              value={data[questionPart.questionPartName]}
              error={errors[questionPart.questionPartName]}
              options={questionPart.questionPartOptions}
              className={''}
              fieldClass={questionPart.questionPartName}
              required={questionPart.questionPartRequired === '1'}
              defaultOption='--Select--'
              onBlur={onBlur}
            />
          );
          if (topRowQuestions.length === 2) {
            questions.push(<div>{topRowQuestions}</div>);
          }
        }
      });
    });
  }

  return (
    <form id='transferForm'>
      <div className='transferFormRow'>
        {topRowQuestions}
      </div>
      <div className='transferFormButtonRow'>
        <Button id='cancelButton' value={"Cancel"} onClick={onCancel} />
        <Button value={'Transfer Establishments'} onClick={(event) => onSubmit(event, data)} disabled={!formIsValid} />
      </div>
    </form>
  );
}

BulkTransferForm.PropTypes = {
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  errors: PropTypes.object,
  data: PropTypes.object,
  formIsValid: PropTypes.bool,
}

export default BulkTransferForm;



/** WEBPACK FOOTER **
 ** ./src/components/bulkTransfer/BulkTransferForm.js
 **/